import { SubCostCenterDto, UpsertSubCostCenterDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/sub-cost-center`;

export const getAllSubCostCentersByCostCenterId = (costCenterId: number, source: CancelTokenSource): Promise<Array<SubCostCenterDto>> => {
  return axios
      .get(`${apiUri}/${costCenterId}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const searchSubCostCentersByDescription = (description: string,
                                               source: CancelTokenSource): Promise<Array<SubCostCenterDto>> => {
  return axios
      .get(`${apiUri}`,{params: {search: description}, cancelToken: source.token})
      .then(response => response.data);
};

export const addSubCostCenter = (upsertSubCostCenterDto: Partial<UpsertSubCostCenterDto>,
                                 source: CancelTokenSource): Promise<SubCostCenterDto> => {
  return axios
      .post(apiUri, upsertSubCostCenterDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editSubCostCenter = (id: number, source: CancelTokenSource ,
                               upsertSubCostCenterDto: Partial<UpsertSubCostCenterDto>): Promise<SubCostCenterDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertSubCostCenterDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteSubCostCenter = (id: number, source: CancelTokenSource): Promise<SubCostCenterDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
